module.exports = __webpack_public_path__ + "static/img/copyRight.982c531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copyRight.png
// module id = G5dJ
// module chunks = 3